export function between(str,char1,char2){
    const start = str.indexOf(char1);
    const end = str.indexOf(char2);
    return str.substring(start,end)+char2;
}
